<template>
  <div class="register">
    <!-- <guide/> -->
    <nav-bar
      :title="lang.register"
      class="nav-bars"
      :show-type="'text'"
    />
    <nav-pc tips="1" />
    <section>
      <div class="reg-wap">
        <van-cell-group>
          <!-- 邮箱 -->
          <van-field
            v-model="reg.email"
            maxlength="50"
            required
            :label="lang.email"
            :placeholder="lang.enter"
            size="large"
          />
          <!-- 确认邮箱 -->
          <van-field
            v-model="reg.reEmail"
            maxlength="50"
            required
            :label="lang.reEmail"
            :placeholder="lang.enter"
            size="large"
          />
          <!-- 手提电话 -->
          <!-- <van-switch-cell v-model="hasPhone" :title="lang.telephone" /> -->
          <van-field
            v-model="reg.telephone"
            type="text"
            maxlength="8"
            required
            :label="lang.telephone + '  +852'"
            :placeholder="lang.enter"
            size="large"
            @blur="checkInt('telephone', 0)"
            @input="checkInt('telephone', 1)"
          />
          <!-- 号码费用提示 -->
          <div class="phone-group">
            <div class="phone-tip">
              {{ lang.phoneTag }}
            </div>
            <!-- <div class="phone-tip" v-if="hasPhone">{{lang.phoneTip}}</div> -->
          </div>
          <!-- 密码 -->
          <van-field
            v-model="reg.password"
            type="password"
            :readonly="isReadonly"
            maxlength="20"
            required
            :label="lang.password"
            :placeholder="lang.enter"
            size="large"
            @focus="fn"
          />
          <!-- 确认密码 -->
          <van-field
            v-model="reg.rePassword"
            type="password"
            :readonly="isReadonly"
            maxlength="20"
            required
            :label="lang.rePassword"
            :placeholder="lang.enter"
            size="large"
            @focus="fn"
          />
        </van-cell-group>
        <!-- 会员名称 -->
        <van-cell-group class="reg-sec">
          <van-field
            v-model="reg.nickName"
            required
            :label="lang.nickName"
            maxlength="20"
            :placeholder="lang.enter"
            size="large"
          />
          <!-- 性别 -->
          <van-cell
            :title="lang.gender"
            is-link
            :value="reg.genderText"
            @click="openSelect('gender')"
          />
          <!-- 年龄 -->
          <van-cell
            :title="lang.ageType"
            is-link
            :value="reg.ageTypeText"
            @click="openSelect('age')"
          />
          <!-- 收入 -->
          <van-cell
            :title="lang.salary"
            is-link
            :value="reg.salaryText"
            @click="openSelect('salary')"
          />
          <!-- 居所 -->
          <!-- <van-cell :title="lang.live" is-link value="内容" @click="openSelect('live')"/> -->
          <!-- 语言 -->
          <van-cell
            :title="lang.languageType"
            required
            is-link
            :value="reg.languageTypeText"
            @click="openSelect('language')"
          />
          <!-- 接受通知 -->
          <van-switch-cell
            v-model="reg.isReceiveSMS"
            :title="lang.news"
          />
        </van-cell-group>
        <van-cell-group class="reg-sec">
          <!-- 是否是持牌代理 -->
          <van-switch-cell
            v-model="reg.isPropertyAgent"
            :title="lang.isPropertyAgent"
            :class="language == 'en-us' ? '' : 'nowarp'"
          />

          <div v-if="reg.isPropertyAgent">
            <div class="agent-group">
              {{ lang.agentTip }}
            </div>
            <van-field
              v-model="reg.companyNameCN"
              maxlength="50"
              required
              :label="lang.companyNameCN"
              :placeholder="lang.enter"
              size="large"
            />
            <van-field
              v-model="reg.companyNameEN"
              maxlength="50"
              :label="lang.companyNameEN"
              :placeholder="lang.enter"
              size="large"
            />
            <van-field
              v-model="reg.companyTelephone"
              type="text"
              maxlength="8"
              required
              :label="lang.companyTelephone"
              :placeholder="lang.enter"
              size="large"
              @input="checkInt('companyTelephone', 1)"
            />
            <van-field
              v-model="reg.companyAddress"
              maxlength="50"
              required
              :label="lang.companyAddress"
              :placeholder="lang.enter"
              size="large"
            />
            <van-field
              v-model="reg.companyLicense"
              maxlength="20"
              required
              :label="lang.companyLicense"
              :placeholder="lang.enter"
              size="large"
            />
            <van-field
              v-model="reg.license"
              maxlength="20"
              required
              :label="lang.license"
              :placeholder="lang.enter"
              size="large"
            />
            <van-field
              v-model="reg.signature"
              :label="lang.signature"
              maxlength="200"
              type="textarea"
              :placeholder="lang.enter"
              size="large"
            />
            <!-- wep图片上传 -->
            <van-cell
              :title="lang.certificate"
              required
            >
              <van-uploader
                class="img-updatas"
                :after-read="onRead"
                :max-size="524288000000"
                accept="image/png, image/jpeg, image/jpg"
              >
                {{ certificate ? '' : lang.wepUpdata }}
                <img
                  :src="certificateUrl"
                  alt
                  class="reg-min-img"
                >
              </van-uploader>
            </van-cell>
            <p class="web-message">
              {{ lang.promptMessage }}
            </p>
          </div>

          <verify
            ref="verify"
            @setVerifyCode="setVerifyCode"
          />
        </van-cell-group>
      </div>

      <div class="reg-pc">
        <div class="flow-pc-box">
          <span class="reg-pc-title">{{ lang.regFlow }}</span>
          <div v-html="lang.flow" />
        </div>

        <div class="flow-pc-box">
          <span class="reg-pc-title">
            {{ lang.regisiter }}
            <router-link
              class="reg-gologin"
              to="/login/"
            >{{ lang.canLogin }}</router-link>
          </span>
        </div>

        <ul class="reg-pc-list">
          <li>
            <!-- 邮箱 -->
            <span class="reg-title">
              {{ lang.email }}
              <label class="reg-required">*</label> :
            </span>
            <input
              v-model="reg.email"
              maxlength="50"
              type="text"
              :placeholder="lang.enter"
            >
            <label class="lab-error error-email" />
          </li>
          <li>
            <!-- 确认邮箱 -->
            <span class="reg-title">
              {{ lang.reEmail }}
              <label class="reg-required">*</label> :
            </span>
            <input
              v-model="reg.reEmail"
              maxlength="50"
              type="text"
              :placeholder="lang.enter"
            >
            <label class="lab-error error-reEmail" />
          </li>
          <!-- <li> -->
          <!-- 手提电话 -->
          <!-- <span class="reg-title"></span> -->
          <!-- <van-checkbox v-model="hasPhone"></van-checkbox> -->
          <!-- </li> -->
          <li>
            <!-- 手提电话 -->
            <span class="reg-title">
              {{ lang.telephone + '(+852)' }}
              <label class="reg-required">*</label> :
            </span>
            <input
              v-model="reg.telephone"
              type="text"
              maxlength="8"
              :placeholder="lang.enter"
              @blur="checkInt('telephone', 0)"
              @input="checkInt('telephone', 1)"
            >
            <label class="lab-error error-telephone" />
          </li>
          <li>
            <div class="phone-group">
              <div class="phone-tip">
                {{ lang.phoneTag }}
              </div>
            </div>
          </li>
          <li>
            <span class="reg-title">
              {{ lang.password }}
              <label class="reg-required">*</label> :
            </span>
            <input
              v-model="reg.password"
              maxlength="20"
              type="password"
              :placeholder="lang.enter"
            >
            <label class="lab-error error-password">{{ lang.password }}{{ lang.pwdReg }}</label>
          </li>
          <li>
            <span class="reg-title">
              {{ lang.rePassword }}
              <label class="reg-required">*</label> :
            </span>
            <input
              v-model="reg.rePassword"
              maxlength="20"
              type="password"
              :placeholder="lang.enter"
            >
            <label class="lab-error error-rePassword" />
          </li>
          <li>
            <!-- 会员名称 -->
            <span class="reg-title">
              {{ lang.nickName }}
              <label class="reg-required">*</label> :
            </span>
            <input
              v-model="reg.nickName"
              maxlength="20"
              type="text"
              :placeholder="lang.enter"
            >
            <label class="lab-error error-nickName" />
          </li>
          <li>
            <!-- 性别 -->
            <span class="reg-title">
              {{ lang.gender }}
              <!-- <label class="reg-required">*</label> -->
              :
            </span>
            <!-- <span><input type="radio" name="gender" :placeholder="lang.enter" :checked="true" v-model="reg.gender">男</span>
            <span><input type="radio" name="gender" :placeholder="lang.enter" v-model="reg.gender">女</span>-->
            <van-radio-group v-model="reg.gender">
              <van-radio
                :name="1"
                value="1"
              >
                {{ lang.male }}
              </van-radio>
              <van-radio
                :name="2"
                value="2"
              >
                {{ lang.female }}
              </van-radio>
            </van-radio-group>
            <label class="lab-error error-gender" />
          </li>
          <li>
            <!-- 年龄 -->
            <span class="reg-title">
              {{ lang.ageType }}
              <!-- <label class="reg-required">*</label>  -->
              :
            </span>
            <select
              v-if="ageList.length > 0"
              v-model="reg.ageType"
            >
              <!-- <option value="">{{lang.select}}</option> -->
              <option
                v-for="i in ageList"
                :key="i.name"
                :value="i.dictionaryValue"
                :name="i.ageType"
              >
                {{ i.name }}
              </option>
            </select>
            <label class="lab-error error-ageType" />
          </li>
          <li>
            <!-- 收入 -->
            <span class="reg-title">{{ lang.salary }} :</span>
            <select
              v-if="salaryList.length > 0"
              v-model="reg.salaryType"
            >
              <!-- <option value="">{{lang.select}}</option> -->
              <option
                v-for="i in salaryList"
                :key="i.name"
                :value="i.dictionaryValue"
                :name="i.salaryType"
              >
                {{ i.name }}
              </option>
            </select>
            <label class="lab-error error-salaryType" />
          </li>

          <li>
            <!-- 语言 -->
            <span class="reg-title">
              {{ lang.languageType }}
              <label class="reg-required">*</label> :
            </span>
            <select v-model="reg.languageType">
              <option :value="false">
                {{ reg.languageTypeText }}
              </option>
              <option :value="1">
                繁體中文 (Trad. Chinese)
              </option>
              <option :value="2">
                簡體中文 (Simp. Chinese)
              </option>
              <option :value="3">
                英文 (English)
              </option>
            </select>
            <label class="lab-error error-languageType" />
          </li>
          <li>
            <!-- 接受通知 -->
            <span class="reg-title">{{ lang.news }} :</span>
            <van-checkbox v-model="reg.isReceiveSMS">
              <span class="modify-proxy gray">{{ lang.agreeSend }}</span>
            </van-checkbox>
          </li>
          <li>
            <!-- 是否是持牌代理 -->
            <span class="reg-title">{{ lang.propertyAgent }} :</span>
            <van-checkbox
              v-model="reg.isPropertyAgent"
              @change="operateProxy"
            >
              <span class="modify-proxy gray">{{ lang.isPropertyAgent }}</span>
            </van-checkbox>
            <span
              v-if="reg.isPropertyAgent"
              class="modify-proxy"
              @click="operateProxy(1)"
            >{{ lang.modify }}</span>
            <br>
            <van-popup
              v-if="reg.isPropertyAgent"
              v-model="showAgentPop"
              :lock-scroll="false"
              class="proxy-pop"
              :close-on-click-overlay="false"
            >
              <div>
                <div class="agent-group">
                  {{ lang.agentTip }}
                </div>
                <ul class="reg-pc-proxy">
                  <li>
                    <span class="reg-title">
                      {{ lang.companyNameCN }}
                      <label class="reg-required">*</label> :
                    </span>
                    <input
                      v-model="reg.companyNameCN"
                      maxlength="50"
                      :placeholder="lang.enter"
                    >
                    <label class="lab-error error-companyNameCN" />
                  </li>
                  <li>
                    <span class="reg-title">{{ lang.companyNameEN }} :</span>
                    <input
                      v-model="reg.companyNameEN"
                      maxlength="50"
                      :placeholder="lang.enter"
                    >
                    <label class="lab-error error-companyNameEN" />
                  </li>
                  <li>
                    <span class="reg-title">
                      {{ lang.companyTelephone }}
                      <label class="reg-required">*</label> :
                    </span>
                    <input
                      v-model="reg.companyTelephone"
                      maxlength="8"
                      :placeholder="lang.enter"
                      @input="checkInt('companyTelephone', 1)"
                    >
                    <label class="lab-error error-companyTelephone" />
                  </li>
                  <li>
                    <span class="reg-title">
                      {{ lang.companyAddress }}
                      <label class="reg-required">*</label> :
                    </span>
                    <input
                      v-model="reg.companyAddress"
                      maxlength="50"
                      :placeholder="lang.enter"
                    >
                    <label class="lab-error error-companyAddress" />
                  </li>
                  <li>
                    <span class="reg-title">
                      {{ lang.companyLicense }}
                      <label class="reg-required">*</label> :
                    </span>
                    <input
                      v-model="reg.companyLicense"
                      maxlength="20"
                      :placeholder="lang.enter"
                    >
                    <label class="lab-error error-companyLicense" />
                  </li>
                  <li>
                    <span class="reg-title">
                      {{ lang.license }}
                      <label class="reg-required">*</label> :
                    </span>
                    <input
                      v-model="reg.license"
                      maxlength="20"
                      :placeholder="lang.enter"
                    >
                    <label class="lab-error error-license" />
                  </li>
                  <li class="li-sign">
                    <span class="reg-title">{{ lang.signature }} :</span>
                    <textarea
                      v-model="reg.signature"
                      maxlength="200"
                      :placeholder="lang.enter"
                    />
                  </li>
                  <!-- 图片上传 -->
                  <li>
                    <span class="reg-title">
                      {{ lang.certificate }}
                      <label class="reg-required">*</label> :
                    </span>

                    <van-uploader
                      class="img-updata"
                      :after-read="onRead"
                      :max-size="524288000000"
                      accept="image/png, image/jpeg, image/jpg"
                    >
                      {{ lang.pcUpdata }}
                    </van-uploader>
                  </li>
                  <li>
                    <span class="reg-title" />
                    <img
                      :src="certificateUrl"
                      alt
                      class="img-border"
                    >
                    <label class="lab-error error-certificate" />
                  </li>
                  <li>
                    <span class="reg-title" />
                    <p class="prompt-message">
                      {{ lang.promptMessage }}
                    </p>
                  </li>
                </ul>
              </div>
              <div class="proxy-btn">
                <div
                  type="default"
                  class="close-reg-proxy"
                  @click="cancelProxy"
                >
                  <svg
                    class="icon icon_heart"
                    aria-hidden="true"
                  >
                    <use xlink:href="#icon-quxiaox" />
                  </svg>
                </div>
                <van-button
                  type="danger"
                  @click="saveProxy"
                >
                  {{ lang.save }}
                </van-button>
              </div>
            </van-popup>
          </li>
          <li>
            <verify
              ref="verifyPc"
              @setVerifyCode="setVerifyCode"
            />
            <label class="lab-error error-verifyCode" />
          </li>
          <!-- <li>
            <div  class="g-recaptcha" data-callback="verifyGoogle" data-sitekey="6LdndqYUAAAAABVCJxlJDtZq89KcRg7pbZweeO1V"></div>
            <label class="lab-error error-verCode "></label>
          </li>-->
          <li>
            <div class="reg-sub">
              <div class="reg-agreement">
                <van-checkbox
                  v-model="agree"
                  class="reg-agree-check"
                />
                <label v-html="lang.agreement" />
                <label class="lab-error error-agree" />
              </div>
              <br>
              <div class="neterror">
                <van-button
                  onclick="dataLayer.push({'event': 'register'})"
                  size="large"
                  type="danger"
                  :loading-text="lang.f_wait"
                  :loading="isWait"
                  @click="goReg"
                >
                  {{
                    lang.goRegister || lang.register
                  }}
                </van-button>
                <label class="lab-error error-network" />
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="reg-sub sub-wap">
        <div class="reg-agreement mt20">
          <van-checkbox
            v-model="agree"
            class="reg-agree-check"
          />
          <label v-html="lang.agreement" />
        </div>
        <!-- <div  class="g-recaptcha reg-wap-verify" data-callback="verifyGoogle" data-sitekey="6LdndqYUAAAAABVCJxlJDtZq89KcRg7pbZweeO1V"></div> -->
        <van-button
          size="large"
          type="danger"
          onclick="dataLayer.push({'event': 'register'})"
          :loading-text="lang.f_wait"
          :loading="isWait"
          @click="goReg"
        >
          {{
            lang.goRegister || lang.register
          }}
        </van-button>
      </div>
    </section>
    <!-- <van-popup v-model="showCheckPop" position="top" :overlay="false" class="error-pop" :lock-scroll="false">
      <span class="error-text">{{errorText}}</span>
    </van-popup>-->
    <van-actionsheet
      v-if="showAction"
      v-model="showAction"
      :actions="actions"
      @select="onSelect"
    />
  </div>
</template>

<script>
// import { Button, NavBar, Icon, Field, Cell, CellGroup, SwitchCell, Actionsheet, Popup, Radio, RadioGroup, Checkbox, Dialog } from 'vant';
import verify from './../components/verify-code';
import lang from './../../common/language/register';
import guide from './../components/guide';
import navBar from './../components/navBar';
import navPc from './../components/navBar-pc';
import register from './../../common/language/register';
export default {
  metaInfo() {
    return {
      title: this.lang.register
    };
  },
  name: 'Register',
  components: {
    // [Button.name]: Button,
    // [NavBar.name]: NavBar,
    // [Icon.name]: Icon,
    // [Field.name]: Field,
    // [Cell.name]: Cell,
    // [CellGroup.name]: CellGroup,
    // [SwitchCell.name]: SwitchCell,
    // [Actionsheet.name]: Actionsheet,
    // [Popup.name]: Popup,
    // [Radio.name]: Radio,
    // [RadioGroup.name]: RadioGroup,
    // [Checkbox.name]: Checkbox,
    // [Dialog.name]: Dialog,
    guide,
    navBar,
    navPc,
    verify
  },
  data() {
    return {
      language: 'zh-hk',
      isReadonly: true,
      DeviceWidth: false,
      cacheNum: '',
      agree: false,
      isWait: false,
      showAgentPop: false,
      lang: lang,
      email: '',
      showAction: false,
      actions: [],
      show: true,
      curSelect: '',
      // showCheckPop: false,
      errorText: '',
      ageList: [],
      salaryList: [],
      certificate: '', //地产代理证
      certificateUrl: '',
      file: null,
      reg: {
        email: '', //邮件
        reEmail: '', //确认邮件
        password: '', //密码
        rePassword: '', //确认密码
        nickName: '', //昵称
        telephone: '', //电话
        isReceiveMessage: true, //是否接收讯息
        isReceiveSMS: true, //是否接收短信
        isPropertyAgent: false, //是否地产代理
        companyNameCN: '', //地产代理公司名称(繁体)
        companyNameEN: '', //地产代理公司名称(英文)
        companyTelephone: '', //公司电话
        companyAddress: '', //公司地址繁体
        // companyAddressEN: "", //公司地址英文
        signature: '', //签名档
        companyLicense: '', //公司License
        license: '', //个人License
        // isImportEstate: "", //是否把资料灌入楼盘中
        // status: "", //状态
        gender: false,
        genderText: lang.select + lang.gender, //性别
        ageType: false, //年龄组别'
        ageTypeText: lang.select + lang.ageType,
        salaryType: undefined, //收入
        salaryText: lang.select + lang.salary,
        // liveType: "", //居所
        languageType: false, //语言类型
        languageTypeText: lang.select + lang.languageText, //语言文本
        verifyCode: '',
        verifyToken: '',
        // imagePath: "" //头像地址
        certificate: '' //地产代理证
      }
    };
  },
  mounted() {
    // 測試數據
    // this.reg={
    //     ageType:"3",
    //     // ageTypeText:"31 - 40",
    //     certificate:"",
    //     companyAddress:"456@qq.com",
    //     companyLicense:"456@qq.com",
    //     companyNameCN:"456@qq.com",
    //     companyNameEN:"456@qq.com",
    //     companyTelephone:"7897984",
    //     email:"456@qq.com",
    //     gender:1,
    //     genderText:"男",
    //     isPropertyAgent:true,
    //     isReceiveMessage:true,
    //     isReceiveSMS:true,
    //     languageType:1,
    //     languageTypeText:"請選擇語言",
    //     license:"111",
    //     nickName:"456@qq.com",
    //     password:"456@qq.com",
    //     reEmail:"456@qq.com",
    //     rePassword:"456@qq.com",
    //     // salaryText:"15,000 - 30,000",
    //     salaryType:"2",
    //     signature:"",
    //     telephone:"47848815",
    //     verifyCode:"",
    //     verifyToken:"",
    // }

    this.language = this.pub.getLang();
    // let _this = this;
    // const script = document.createElement("script");
    // script.type = "text/javascript";
    // script.src = this.pub.config.googleVerify;
    // document.body.appendChild(script);
    // window.verifyGoogle = response => (_this.verifyCode = response);
    if (window.dataLayer) {dataLayer.push({ pageCategory: 'homepage' });}
    setTimeout(() => {
      if (typeof gtag === 'function') {
        gtag('config', 'UA-139040958-2', {
          custom_map: {
            metric1: 'register'
          }
        });
      }
    }, 500);
  },
  created() {
    // this.pub.getDictionary().then(res => console.log(res));
    this.axios.get(this.pub.getApi().GetRecaptcha).then(res => {
      if (res.data.code === 0) {
        this.verifyImg = 'data:image/png;base64,' + res.data.result.image;
        this.verifyToken = res.data.result.token;
      }
    });

    this.pub.getDictionary().then(res => {
      this.ageList.push({
        dictionaryValue: false,
        name: this.reg.ageTypeText,
        value: false,
        dictionaryNameWithCulture: this.reg.ageTypeText
      });
      this.salaryList.push({
        dictionaryValue: undefined,
        name: this.reg.salaryText,
        value: undefined,
        dictionaryNameWithCulture: this.reg.salaryText
      });

      res.AgeType.children.forEach(e => {
        // console.log(e)
        this.ageList.push({ ...e, name: e.dictionaryNameWithCulture });
      });
      res.SalaryType.children.forEach(e => {
        this.salaryList.push({ ...e, name: e.dictionaryNameWithCulture });
      });
    });
  },
  methods: {
    // 图片上传
    async onRead(file) {
      if (!file.file.name.toLocaleLowerCase().match(/(.*)\.(jpg|jpeg|png)$/)) {
        this.showError('certificate', lang.errorImg);
        // this.$notify(lang.errorImg);
        return;
      }
      if (file) {
        let reader = new FileReader();
        reader.readAsDataURL(file.file);
        const _this = this;
        reader.onload = function() {
          _this.certificateUrl = this.result;
        };
      }

      this.certificate = file.file;
      // console.log(formData);
      // const res = await this.axios.post(this.pub.getApi().Upload, this.formData);
      // console.log(res);
      // if (res.data.code === 0 && res.data.result) {
      //   this.reg.certificate = res.data.result[0].url;
      //   this.certificate = res.data.result[0].url;
      // } else {
      //   this.showError('certificate', lang.imgfailure);
      //   this.$notify(lang.picfailure);
      // }
    },
    // 鼠标失焦禁用浏览器保存密码提示
    fn() {
      this.isReadonly = false;
    },
    //设置验证码
    setVerifyCode(verifyCode, verifyToken) {
      // console.log('设置验证码', this.reg);
      this.reg.verifyCode = verifyCode;
      this.reg.verifyToken = verifyToken;
    },

    //检测数字
    checkInt(field, type) {
      const num = this.reg[field];
      type === 0
        ? (this.cacheNum = '' && num.endsWith('.') ? (this.reg[field] = num.substring(0, num.length - 2)) : '')
        : /^$|^\d+$/.test(num)
        ? (this.cacheNum = num)
        : (this.reg[field] = this.cacheNum);
      if (num && (num[0] == 0 || num[0] == 1)) {this.reg[field] = num.replace(num[0], '');}
    },
    showPwds() {
      this.showPwd = !this.showPwd;
    },
    onSelect(item) {
      switch (this.curSelect) {
        case 'salary':
          this.reg.salaryText = item.name;
          this.reg.salaryType = item.itemName;
          break;
        case 'gender':
          this.reg.genderText = item.name;
          this.reg.gender = item.value;
          break;
        case 'age':
          this.reg.ageType = item.itemName;
          this.reg.ageTypeText = item.name;
          break;
        case 'language':
          this.reg.languageType = item.value;
          this.reg.languageTypeText = item.name;
          break;
        default:
          break;
      }
      this.actions = [];
      this.showAction = false;
    },
    openSelect(type) {
      this.actions = [];
      this.curSelect = type;
      // console.log(type);
      switch (type) {
        case 'gender':
          this.actions = [{ name: lang.select + lang.gender, value: false }, { name: lang.male, value: 1 }, { name: lang.female, value: 2 }];
          break;
        case 'age':
          this.actions = this.ageList;

          break;
        case 'salary':
          this.actions = this.salaryList;
          break;
        // case "live":
        //   this.actions = [{ name: "居所" }, { name: "私人住宅" }];
        //   break;
        case 'language':
          this.actions = [{ name: '繁體中文 (Trad. Chinese)', value: 1 }, { name: '簡體中文 (Simp. Chinese)', value: 2 }, { name: '英文 (English)', value: 3 }];
          break;
        default:
          break;
      }
      this.showAction = true;
    },
    goReg() {
      if (typeof gtag === 'function') {
        gtag('event', 'register', {
          register: 1
        });
      }

      this.isWait = true;
      this.checkForm('');
      setTimeout(() => (this.isWait = false), 4000);
      if (this.checkForm(document.body.clientWidth > 600 ? 'pc' : '')) {
        this.reg.isReceiveMessage = this.reg.isReceiveSMS;
        let platform = document.body.clientWidth > 600 ? 'pc' : 'wap';
        const fromapp = this.$route.query.fromapp;
        if (fromapp) {
          platform = fromapp == 'ios' ? 'app-ios' : 'app-android';
        }

        let formData = new FormData();
        Object.keys(this.reg).forEach(key => {
          if (this.reg[key]) {formData.append(key, this.reg[key]);}
        });
        formData.append('AgentCard', this.certificate);
        this.axios
          .post(this.pub.getApi().RegisterUser, formData, {
            params: {
              'h-recaptchavalue': this.reg.verifyCode,
              'h-recaptcha': this.reg.verifyToken,
              platform: platform
            }
          })
          .then(
            res => {
              this.isWait = false;
              this.reg.verifyCode = '';
              this.reg.verifyToken = '';
              this.verifyCode = this.verifyToken = '';
              if (res.data.code === 0) {
                this.$router.push('/account/tips/?type=1&email=' + this.reg.email);
              } else if (res.data.code === 1309) {this.showError('telephone', `${this.lang.hasExist.replace('@@', this.lang.telephone)}`);}
              else if (res.data.code === 1308) {this.showError('email', `${this.lang.hasExist.replace('@@', this.lang.emailText)}`);}
              else if (res.data.code === 101 || res.data.code === 103) {
                this.showError('verifyCode', this.lang.verifyError);
                this.$refs.verify.loadImg();
              }
              document.body.clientWidth < 600 ? this.$refs.verify.loadImg() : this.$refs.verifyPc.loadImg();
            }
            //   () =>{
            //  this.isWait = false;
            //  this.showError("network", this.lang.networkError);
            //   }
          )
          .catch(e => {
            this.isWait = false;
            this.showError('network', this.lang.networkError);
          });
      } else {this.isWait = false;}
    },
    //pc端 保存代理信息
    saveProxy() {
      if (this.checkForm('proxy')) {this.showAgentPop = false;}
    },
    //验证所有文本框
    checkForm(type) {
      // console.log('Kaishi ');
      const el = document.querySelectorAll('.lab-error');
      for (let i = 0; i < el.length; i++) {
        el[i].classList.remove('error-show');
      }
      let result = true;
      let regList = type === 'proxy' ? [] : ['email', 'reEmail', 'password', 'rePassword', 'telephone', 'nickName', 'languageType', 'verifyCode'];
      const proxyList = ['companyNameCN', 'companyTelephone', 'companyAddress', 'companyLicense', 'license'];
      //如果勾选了持牌代理,则将持牌代理字段加入表单验证
      if (this.reg.isPropertyAgent) {regList = [...regList, ...proxyList];}
      else {
        proxyList.forEach(p => (this.reg[p] = ''));
        this.reg.companyNameEN = '';
        this.reg.signature = '';
      }
      /**验证格式之前  去除掉邮箱头尾的空格 */
      this.reg.email = this.reg.email.trim();
      this.reg.reEmail = this.reg.reEmail.trim();
      //批量验证必填字段
      for (let i = 0; i < regList.length; i++) {
        // console.log(regList[i])
        if (typeof this.reg[regList[i]] !== 'number' && !this.reg[regList[i]]) {
          this.showError(regList[i], `${this.lang.null}${this.lang[regList[i]]}`);
          regList[i] == 'telephone' ? this.showError(regList[i], `${this.lang.null}${this.lang.linkPhone}`) : '';
          // regList[i] == "password" ?this.showError(regList[i], `${this.lang.null}${this.lang.password}`) : "";
          regList[i] == 'rePassword' ? this.showError(regList[i], this.lang.confirmPassword) : '';
          regList[i] == 'reEmail' ? this.showError(regList[i], this.lang.confirmEmail) : '';
          regList[i] == 'gender' || regList[i] == 'ageType' || regList[i] == 'gender' ? this.showError(regList[i], `${this.lang.pleaseSel}${this.lang[regList[i]]}`) : '';
          regList[i] == 'languageType' ? this.showError(regList[i], `${this.lang.pleaseSel + this.lang.languageText}`) : '';
          regList[i] == 'companyLicense' || regList[i] == 'license' ? this.showError(regList[i], `${this.lang.null}${this.lang[regList[i]] + lang.number}`) : '';
          regList[i] == 'email' ? this.showError(regList[i], this.lang.emailNull) : '';
          // console.log(regList[i]);
          // regList[i]=='certificate'&&? : '';
          //如果是pc端验证所有字段,wap端失败一项不再验证
          if (!type) {return false;}
          result = false;
        }
      }

      if (this.reg.isPropertyAgent && !this.certificate) {
        this.showError('certificate', this.lang.imgNull);
        return;
      }
      //验证密码和邮箱是否两次输入一致
      //验证密码复杂度 邮箱格式
      if (type !== 'proxy') {
        this.reg.telephone != '' && (this.reg.telephone[0] == '0' || this.reg.telephone[0] == '1') ? (this.showError('telephone', this.lang.telError), (result = false)) : '';
        this.reg.password !== this.reg.rePassword && this.reg.rePassword !== '' ? (this.showError('rePassword', this.lang.differentPassword), (result = false)) : '';
        this.reg.password && !/^(?=.*[0-9])(?=.*[a-zA-Z])(.{6,20})$/.test(this.reg.password) ? (this.showError('password', `${this.lang.pwdError}`), (result = false)) : '';
        this.reg.password && this.reg.password.indexOf(' ') > -1 ? (this.showError('password', `${this.lang.password} ${this.lang.cantSpace}`), (result = false)) : '';
        this.reg.email !== this.reg.reEmail ? (this.showError('reEmail', this.lang.differentEmail), (result = false)) : '';
        (this.reg.email && !/^[a-zA-Z0-9]+([\.a-zA-Z0-9_-]*)+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.reg.email)) || this.reg.email.indexOf('__') > -1
          ? (this.showError('email', `${this.lang.emailReg}`), (result = false))
          : '';
        !this.agree ? (this.showError('agree', this.lang.agreeError), (result = false)) : '';
      } else {
        this.reg.companyTelephone != '' && (this.reg.companyTelephone[0] == '0' || this.reg.companyTelephone[0] == '1')
          ? (this.showError('companyTelephone', `${this.lang.telError}`), (result = false))
          : '';
      }
      const errorsShow = document.querySelector('.error-show');
      if (errorsShow && type !== 'proxy') {
        const height = errorsShow.offsetTop;
        document.body.scrollTop = document.documentElement.scrollTop = height - 300;
      }

      // console.log('结果', result, this.agree);
      return result;
    },

    //显示错误信息
    showError(el, text) {
      // console.log('显示错误');
      if (document.body.clientWidth > 600) {
        const element = document.querySelector(`.error-${el}`);
        // console.log(el, element,text)
        element.innerHTML = text;
        element.classList.add('error-show');
      } else {
        // this.errorText = text;
        // this.showCheckPop = true;
        // setTimeout(() => this.showCheckPop = false, 3000);
        this.$notify(text);
      }
    },
    cancelProxy() {
      //如果内容未填写完整点取消,则关闭弹窗并取消勾选
      const proxyList = ['companyNameCN', 'companyTelephone', 'companyAddress', 'companyLicense', 'license'];
      for (let k = 0; k < proxyList.length; k++) {
        if (!this.reg[proxyList[k]]) {
          this.showAgentPop = this.reg.isPropertyAgent = false;
          return;
        }
      }
      if (!this.certificate) {
        this.showAgentPop = this.reg.isPropertyAgent = false;
        return;
      }
      this.showAgentPop = false;
    },
    operateProxy(type) {
      if (type) {this.showAgentPop = this.reg.isPropertyAgent = true;}
      else if (this.reg.isPropertyAgent) {
        this.showAgentPop = true;
      }
    }
  }
};
</script>
